import Api from "@/assets/api/questionnaire";
const state = {
  pageType: "list",
  selectedData: {},
};
const mutations = {
  SET_PAGETYPE(state, val) {
    state.pageType = val;
  },
  SET_SELECTEDDATA(state, val) {
    state.selectedData = val;
  },
  INIT_QUESTIONNAIRE(state) {
    state.pageType = "list";
    state.selectedData = {};
  },
};
const actions = {};
const getters = {
  showTabs: (state) => {
    return !["setting", "send", "detail", "stats"].includes(state.pageType);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
